import {service as SpeciesNativityService} from "../../../Services/SpeciesNativityService";
import {service as SpeciesInvasivityService} from "../../../Services/SpeciesInvasivityService";
import {service as SpeciesTypeService} from "../../../Services/SpeciesTypeService";
export const SpeciesListSpeciesFieldServices = {
    alternativeLatinName: null,
    alternativeCommonName: null,
    speciesTypeId: SpeciesTypeService,
    speciesNativityId: SpeciesNativityService,
    speciesInvasivityId: SpeciesInvasivityService
};


